import type { PropsWithChildren } from 'react';
import type React from 'react';

import { useCurrentUser } from '#src/app/shared/hooks/session';
import { isLoaded } from '#src/app/shared/utils/async';

import type { LoginOrSignupPagePrefetchedContext } from './hook';
import { usePageContext } from './hook';
import { LoginOrSignupPageDataContextProvider } from './pageData';
import { LoginOrSignupPageStateContextProvider } from './pageState';

type Props = {
	prefetchedData: LoginOrSignupPagePrefetchedContext | undefined;
	loadingFallback: JSX.Element;
};

export const LoginOrSignupPageContextProvider: React.FC<PropsWithChildren<Props>> = ({
	loadingFallback,
	prefetchedData,
	children,
}) => {
	const pageContextState = usePageContext(prefetchedData);
	const user = useCurrentUser();

	if (!isLoaded(pageContextState)) return loadingFallback;

	const { pageData } = pageContextState;

	return (
		<LoginOrSignupPageDataContextProvider pageData={pageData}>
			<LoginOrSignupPageStateContextProvider email={user?.email}>{children}</LoginOrSignupPageStateContextProvider>
		</LoginOrSignupPageDataContextProvider>
	);
};
